module.exports = __webpack_public_path__ + "static/media/androidApp.cf34c4c9.gif";